/* FOUR TO TWO — scroll scrubs one night at Cabel's, 4:00 PM → 2:00 AM */
(function () {
  'use strict';

  // ?rm=1 mirrors the reduced-motion JS branch for automated tests (CSS branch keys off the real media feature)
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    new URLSearchParams(location.search).has('rm');
  var body = document.body;
  var clock = document.getElementById('clock');
  var sun = document.querySelector('.sun');
  var dayL = document.querySelector('.sky-day');
  var duskL = document.querySelector('.sky-dusk');
  var nightL = document.querySelector('.sky-night');
  var heroTitle = document.getElementById('heroTitle');
  var stage = document.getElementById('stage');

  /* ---- facts: hours + tonight's deal (source: PHASE0.md) ---- */
  // open hour, close hour (24h; close > 24 means past midnight)
  var HOURS = [
    [16, 24], // Sun
    [16, 24], // Mon
    [16, 26], // Tue
    [16, 26], // Wed
    [16, 26], // Thu
    [16, 26], // Fri
    [11, 26]  // Sat
  ];
  var DEALS = [
    'Sunday Funday · $3 mimosas',
    '$8 XX pitchers',
    'Dollar Beer Night · $1.50 domestics',
    '$3.50 margaritas & Modelos',
    'Teas Get Degrees · $8 teas',
    '$3.50 Jägerbombs',
    '$4 Suncruisers'
  ];

  function fmt12(mins) {
    var h = Math.floor(mins / 60) % 24;
    var m = mins % 60;
    var ap = h >= 12 ? 'PM' : 'AM';
    var h12 = h % 12; if (h12 === 0) h12 = 12;
    return h12 + ':' + (m < 10 ? '0' + m : m) + ' ' + ap;
  }

  function openStatus() {
    var now = new Date();
    var day = now.getDay();
    var t = now.getHours() + now.getMinutes() / 60;
    var todays = HOURS[day];
    // early morning counts as yesterday's late window
    var yest = HOURS[(day + 6) % 7];
    if (t < 4 && yest[1] > 24 && t + 24 < yest[1]) return 'open now · til ' + fmt12((yest[1] % 24) * 60);
    if (t >= todays[0] && t < Math.min(todays[1], 24)) {
      return 'open now · til ' + fmt12((todays[1] % 24) * 60);
    }
    if (t < todays[0]) return 'opens ' + fmt12(todays[0] * 60);
    return 'see you tomorrow';
  }

  var deal = document.getElementById('tonightDeal');
  var status = document.getElementById('openStatus');
  var today = new Date().getDay();
  if (deal) deal.textContent = DEALS[today];
  if (status) status.textContent = openStatus();

  // flag tonight's row in the Line-Up
  document.querySelectorAll('.lineup-row').forEach(function (row) {
    if (Number(row.getAttribute('data-day')) === today) row.classList.add('tonight');
  });

  /* ---- reveals ---- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.18 });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });

  // the climax: the big sign buzzes on when you reach it
  var bigSign = document.getElementById('bigSign');
  if (bigSign) {
    var signIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { bigSign.classList.add('lit'); signIO.disconnect(); }
      });
    }, { threshold: 0.5 });
    signIO.observe(bigSign);
  }

  /* ---- the night scrub ---- */
  var skyline = document.getElementById('skyline');
  var wins = skyline ? [].slice.call(skyline.querySelectorAll('.win')) : [];
  var sign = document.getElementById('barSign');

  if (reduced) {
    // designed reduced-motion state: rest at dusk, clock shows the real status
    body.setAttribute('data-phase', 'dusk');
    if (dayL) dayL.style.opacity = '0';
    if (duskL) duskL.style.opacity = '1';
    if (nightL) nightL.style.opacity = '0.35';
    if (sun) sun.style.opacity = '0';
    if (clock) clock.textContent = openStatus();
    if (skyline) skyline.style.opacity = '0.9';
    if (sign) sign.classList.add('lit');
    if (bigSign) bigSign.classList.add('lit');
    wins.forEach(function (w, i) { if (i % 2 === 0) w.style.opacity = '1'; });
    // designed rest for the photo stage: a calm blue-hour patio, lights on
    if (stage) {
      stage.style.setProperty('--day-op', '0.20');
      stage.style.setProperty('--night-op', '0.85');
      stage.style.setProperty('--dusk', '0.5');
      stage.style.setProperty('--bloom', '0.55');
      stage.style.setProperty('--stage', '1');
    }
    return;
  }

  var docH = 1, winH = 1, pending = false;

  function schedule() {
    if (!pending) { pending = true; requestAnimationFrame(frame); }
  }
  function measure() {
    winH = window.innerHeight;
    docH = document.documentElement.scrollHeight - winH;
    if (docH < 1) docH = 1;
    schedule();
  }
  window.addEventListener('resize', measure, { passive: true });
  window.addEventListener('scroll', schedule, { passive: true });

  function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function smooth(a, b, v) { var x = clamp01((v - a) / (b - a)); return x * x * (3 - 2 * x); }

  var lastClock = '';
  function render(t) {
    {
      if (t > 0.99) t = 1;

      // ambient sky (behind the photo stage; reaches full night as the stage fades out)
      var day = 1 - smooth(0.05, 0.22, t);
      var dusk = smooth(0.08, 0.18, t) * (1 - smooth(0.28, 0.42, t));
      var night = smooth(0.26, 0.42, t);
      dayL.style.opacity = day.toFixed(3);
      duskL.style.opacity = dusk.toFixed(3);
      nightL.style.opacity = night.toFixed(3);

      // THE SIGNATURE: the patio photo goes 4 o'clock daylight -> 2 a.m. neon,
      // then the whole stage dissolves into the ambient night for the sections below.
      if (stage) {
        stage.style.setProperty('--day-op', (1 - smooth(0.05, 0.20, t)).toFixed(3));
        stage.style.setProperty('--night-op', smooth(0.10, 0.26, t).toFixed(3));
        stage.style.setProperty('--dusk', (smooth(0.07, 0.16, t) * (1 - smooth(0.24, 0.34, t))).toFixed(3));
        stage.style.setProperty('--bloom', smooth(0.20, 0.34, t).toFixed(3));
        stage.style.setProperty('--stage', (1 - smooth(0.30, 0.44, t)).toFixed(3));
      }

      // sun sinks
      var sunY = t * 2.2 * winH;
      sun.style.transform = 'translateY(' + sunY.toFixed(1) + 'px)';
      sun.style.opacity = (1 - smooth(0.38, 0.5, t)).toFixed(3);

      // the town: rooftops harden as the light goes; windows come on one by one.
      // It recedes for the midnight quote + ignition beats, returns for last call.
      if (skyline) {
        var town = 0.22 + 0.78 * smooth(0.12, 0.5, t);
        town *= 1 - 0.72 * (smooth(0.66, 0.72, t) * (1 - smooth(0.9, 0.97, t)));
        skyline.style.opacity = town.toFixed(3);
        for (var i = 0; i < wins.length; i++) {
          wins[i].style.opacity = t >= Number(wins[i].getAttribute('data-on')) ? '1' : '0';
        }
        if (sign) sign.classList.toggle('lit', t >= 0.45);
      }

      // clock: 4:00 PM (960) → 2:00 AM (1560), 5-minute steps
      var mins = 960 + Math.round(t * 600 / 5) * 5;
      var label = fmt12(mins);
      if (label !== lastClock) {
        lastClock = label;
        clock.textContent = label;
        var chipLabel = document.querySelector('.hud-clock-label');
        if (chipLabel) chipLabel.textContent = t >= 0.96 ? 'last call' : (mins < 1050 ? 'today' : 'tonight');
      }

      // phase for HUD color flips (night lands ~t.30, aligned with the stage handoff)
      var phase = t < 0.14 ? 'day' : t < 0.30 ? 'dusk' : 'night';
      if (body.getAttribute('data-phase') !== phase) body.setAttribute('data-phase', phase);

      // hero type narrows as the sun drops through the first screens
      if (heroTitle) {
        var tw = clamp01(t / 0.18);
        var wdth = 125 - tw * 45;
        heroTitle.style.fontVariationSettings = "'wdth' " + wdth.toFixed(1) + ", 'wght' 800";
      }
    }
  }
  function frame() {
    pending = false;
    render(clamp01(window.scrollY / docH));
  }
  // pointer parallax: the stage planes tilt against the cursor (fine pointers only, non-reduced)
  if (stage && window.matchMedia('(pointer: fine)').matches) {
    var px = 0, py = 0, tpx = 0, tpy = 0, praf = false;
    function applyP() {
      praf = false;
      px += (tpx - px) * 0.12;
      py += (tpy - py) * 0.12;
      stage.style.setProperty('--px', px.toFixed(4));
      stage.style.setProperty('--py', py.toFixed(4));
      if (Math.abs(tpx - px) > 0.0015 || Math.abs(tpy - py) > 0.0015) { praf = true; requestAnimationFrame(applyP); }
    }
    window.addEventListener('pointermove', function (e) {
      tpx = (e.clientX / window.innerWidth) * 2 - 1;
      tpy = (e.clientY / window.innerHeight) * 2 - 1;
      if (!praf) { praf = true; requestAnimationFrame(applyP); }
    }, { passive: true });
  }

  measure();
  // test hook: lets automated checks drive a frame synchronously (rAF stalls in hidden tabs)
  window.__night = { frame: frame, render: render, measure: measure, stage: stage };
})();
